<template>
        <div>
            <CRow>
                <CCol>
                    <div style="width:100%; height: 80vh;">
                        <ejs-grid ref='grid'
                                  :dataSource='data'
                                  :allowFiltering='true'
                                  :allowPaging='true'
                                  :allowResizing='true'
                                  :allowReordering='true'
                                  :allowSorting='true'
                                  :toolbar='toolbar'
                                  :pageSettings='pageSettings'
                                  :filterSettings='filterOptions'
                                  :toolbarClick='toolbarClick'
                                  :allowExcelExport='true'
                                  :excelExportComplete='excelExportComplete'
                                  :query='query'
                                  :actionBegin ='actionBegin'
                                  :actionComplete ='actionComplete'
                                  :actionFailure ='actionFailure'
                                  :enablePersistence ="true"
                                  :recordDoubleClick="recordDoubleClick" width="100%" height="100%">
                            <e-columns>
                                <e-column field='clientId' headerText='Id' :isPrimaryKey='true' :visible='true' width=160 type="number"></e-column>
                                <e-column field='parentName' headerText='Client' width=270 type="string"></e-column>
                                <e-column field='clientName' headerText='Company' width=270 type="string"></e-column>
                                <!--<e-column field='address' headerText='Address' width=300></e-column>
                                <e-column field='postcode' headerText='Postal Code' width=160></e-column>-->
                                <e-column field='stateName' headerText='Country' width=150 type="string"></e-column>
                                <e-column field='sectorName' headerText='Classification' width=160 type="string"></e-column>
                                <e-column field='status' headerText='Status' width=120 type="string"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </CCol>
            </CRow>
        </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    let DialogConfirmDeleteCompany = undefined;

    export default {
        name: 'Companies',
        data() {
            return {
                data: SyncHelper.getDataManager("company"),
                pageSettings: gridOptions.pageSettings,
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddClient' },
                          { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditClient' },
                          { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteClient' },
                          'ExcelExport'],
                filterOptions: gridOptions.filterSettings
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddClient') {
                    this.$router.push({ name: "Company" });
                }
                if (args.item.id === 'EditClient') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        this.$router.push({ name: "Company", params: { clientId: selectedClient[0].clientId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a company first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id === 'DeleteClient') {
                     var selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient) {
                        DialogConfirmDeleteCompany = DialogUtility.confirm({
                            title: 'Confirm Delete',
                            content: "Are you sure you want to delete company '" + selectedClient[0].clientName + "'?" ,
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.confirmDeleteCompany },
                            cancelButton: { text: 'Cancel', click: this.cancelDeleteCompany },
                            open: () => {
                                this.$refs.focusElement.focus();
                            },
                            showCloseIcon: true,
                            closeOnEscape: true,
                        });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Companies.xlsx", this.$refs);
                }
            },

            confirmDeleteCompany: function () {
                let selectedClient = this.$refs.grid.getSelectedRecords();
                apis.protectedApi.delete(`company/${selectedClient[0].clientId}`)
                    .then(response => {
                        this.$refs.grid.refresh()
                        let message = { title: 'Success!', content: 'Company is deleted successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                    }).catch(e => {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    });
                DialogConfirmDeleteCompany.hide();
            },

            cancelDeleteClient: function () {
                DialogConfirmDeleteCompany.hide();
            },

            recordDoubleClick: function (e) {
                this.$router.push({ name: "Company", params: { clientId: e.rowData.clientId } });
            }, 
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            setToolbarVisibility: function () {
                if (!this.$store.state.permissions["Permissions.Client.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddClient'], false);
                }
                if (!this.$store.state.permissions["Permissions.Client.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteClient'], false);
                }
                if (!this.$store.state.permissions["Permissions.Client.Update"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditClient'], false);
                }
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            }
        },
        computed: {
            query: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            }
        },
        mounted() {
            this.setToolbarVisibility();
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    } 
</script>

<style scoped>
</style>